import React from 'react';

const Display = ({ display }) => {
    return <div id='display'>{display}</div>;
};

export default Display;
